import * as yup from 'yup';
import { VALIDATION_MESSAGES } from '@/constants';

const validationSchema = yup.object({
  firstName: yup
    .string()
    .min(2, VALIDATION_MESSAGES.FIRST_NAME_MIN)
    .required(VALIDATION_MESSAGES.FIRST_NAME_REQUIRED),
  lastName: yup
    .string()
    .min(2, VALIDATION_MESSAGES.LAST_NAME_MIN)
    .required(VALIDATION_MESSAGES.LAST_NAME_REQUIRED),
});

export default validationSchema;
